import {ObvioEvent} from 'Event'
import {Client} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useQuery} from 'react-query'

export type ObieMilestone = {
  id: string
  name: string
}

export function useObieMilestones(params: {
  client: Client
  event: ObvioEvent
  obieJourneyId: string
}) {
  const {client, event, obieJourneyId} = params

  return useQuery<ObieMilestone[], {message: string; status?: number}>({
    queryKey: [
      'events',
      event.id,
      'integrations',
      'obie',
      'milestones',
      obieJourneyId,
    ],
    queryFn: () =>
      client.get<ObieMilestone[]>(
        api(
          `/events/${event.id}/integrations/obie/milestones?obie_journey_id=${obieJourneyId}`,
        ),
      ),
    retry: (failureCount, error) => error.status !== 404 && failureCount < 3,
  })
}
